import React from 'react';
import Label from 'components/form/Label/Label';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { Link } from 'components/navigation/Link/Link';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { useState } from 'react';
import { Image } from 'components/Image/Image';
import classnames from 'classnames';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import {
  getHideSignUpBanner,
  setHideSignUpBanner,
} from 'helpers/sessionstorage';

export const SignUpBanner = props => {
  const { eventHandler, isFreeSignUpBannerShow, className } = props;
  const [showBanner, setShowBanner] = useState(true);

  const hideSignUpBanner = getHideSignUpBanner();

  const SignupCloseClick = () => {
    setShowBanner(false);
    setHideSignUpBanner(true);
  };

  const seenPixel = useSeenModulePixel(
    getViewModuleTrackingAttributes({
      moduleName: 'Top Banner',
    }),
  );

  const SignupEvent = () => {
    eventHandler(CLICK, {
      'Click Type': `${isFreeSignUpBannerShow?.clickTypeSignUpBanner}`,
    });
  };

  if (showBanner && !hideSignUpBanner) {
    return (
      <>
        {seenPixel}
        <FlexContainer
          className={classnames(
            ' bgBlue015 height-40px padlr10 width100',
            className,
          )}
        >
          <FlexContainer className="items-align-center justify-center width100">
            <Label type="Subtitle-2">
              {isFreeSignUpBannerShow?.textSignUpBanner}{' '}
              {isFreeSignUpBannerShow?.linkTextSignUpBanner && (
                <Link
                  onClickCallback={SignupEvent}
                  to={isFreeSignUpBannerShow?.linkSignUpBanner}
                  ariaLabel={`${isFreeSignUpBannerShow?.linkTextSignUpBanner}`}
                >
                  <span className="bold pointer fontNeutral800 underline">
                    {isFreeSignUpBannerShow?.linkTextSignUpBanner}
                  </span>
                </Link>
              )}
            </Label>
          </FlexContainer>
          <FlexContainer
            className="items-align-center pointer"
            onClick={SignupCloseClick}
          >
            <Image className="notificationCloseButton" />
          </FlexContainer>
        </FlexContainer>
      </>
    );
  } else {
    return <></>;
  }
};
